import BiliAjax from '@bilibili/bili-app-ajax'
import Vue from 'vue'

import { objectToHump, toLine } from './index'
const inServer = typeof window === undefined
const http = new BiliAjax({
    useCookie: true,
})
export default function({
    url,
    data,
    method = 'get',
    errorToast = true,
    trans = true,
    ...config
}) {
    const prefix = ''
    let usePath = url
    if (usePath.includes('//')) {
        usePath = url
    } else {
        usePath = `${inServer ? 'http' : window.location.protocol}//${prefix}api.bilibili.com${usePath}`
    }
    return http[method](usePath, data, config).then(res => {
            if (trans) {
                if (res.code === 0) {
                    const { data } = res
                    return objectToHump(data)
                } else if (errorToast){
                    Vue.prototype.$toast && Vue.prototype.$toast.info(res.message || '网络错误请稍后重试')
                    return Promise.reject(res)
                }
            } else {
                return objectToHump(res)
            }
        }).catch(err => {
            if (errorToast) {
                Vue.prototype.$toast && Vue.prototype.$toast.info(err.message || '网络错误请稍后重试')
            }
            return Promise.reject(err)
        })
}